import { formatIban, formatToCurrency } from "@utils/formatting";
import { VariantCard } from "@academy-context/primary/shared/external-provider-batch-display/variant-card.content";
import { PdfLink } from "@shared-kernel/primary/shared/pdf-preview-hover-card/pdf-link";
import type { ExternalProviderDashboardVM } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import type { SubmittedInvoiceData } from "@academy-context/write/application/use-cases/external-provider/invoice-submission/submit-external-provider-invoice";

interface Props {
  data: ExternalProviderDashboardVM;
  optimisticInvoice: SubmittedInvoiceData | null;
}

export const InvoiceSectionReadOnly = ({ data, optimisticInvoice }: Props) => {
  // Use optimistic data if available (just submitted), otherwise use server data
  const displayData = optimisticInvoice
    ? optimisticInvoice
    : data.invoice
      ? {
          invoiceNumber: data.invoice.invoiceNumber,
          invoiceUrl: data.invoice.invoiceUrl,
          amount: data.invoice.amount,
          iban: data.provider.iban,
        }
      : null;

  if (!displayData) return null;

  return (
    <VariantCard title="Facture" variant="provider">
      <div className="grid grid-cols-2 gap-2 text-sm">
        <div>
          <span className="text-muted-foreground">N° de facture:</span> {displayData.invoiceNumber}
        </div>
        <div>
          <span className="text-muted-foreground">Montant:</span>{" "}
          <span className="font-semibold">{formatToCurrency(displayData.amount)}</span>
        </div>
        {displayData.iban && (
          <div>
            <span className="text-muted-foreground">IBAN:</span> <code className="text-xs">{formatIban(displayData.iban)}</code>
          </div>
        )}
        {displayData.invoiceUrl && (
          <div>
            <PdfLink documentUrl={displayData.invoiceUrl} label="Voir la facture" />
          </div>
        )}
      </div>
    </VariantCard>
  );
};
